export const poolList = ['RE', 'TA', 'SO', 'ODW', 'CMS', 'CMI', 'OCT','STK','PC','AU','WAS','PSE'];

export const internalApps = ['BPC', 'CA', 'CAR', 'FCIS'];

export const formatRoles = (pool, roles) => {
	let finalRoles = [];
	if (pool === 'REPOST-DEV') {
		let format = [];
		roles.forEach(item => item.roles && format.push(...item.roles));
		format.forEach((role, index) => {
			finalRoles.push({
				id: role,
				label: role
			});
		});
	} else if (pool === 'DS') {
		let format = [];
		roles.forEach(item => item.roles && format.push(...item.roles));
		format.forEach((role, index) => {
			finalRoles.push({
				id: role.role_name,
				label: `${role.role_name}${role.role_desc ? `-${role.role_desc}` : ''}`
			});
		});
	} else {
		let format = [];
		roles.forEach(item => item.roles && format.push(...item.roles));
		format.forEach((role, index) => {
			finalRoles.push({
				id: role.role_name,
				label: role.role_name
			});
		});
	}
	return finalRoles;
};

export const mandatoryFields = {
	roles: {
		DS: false,
		SP: false,
	},
	autoApproval: {
		DS: false,
		SP: true,
		STK: true,
	},
	// isPermanentPassword: {
	// 	DS: false,
	// 	SP: false,
	// 	GA: false,
	// },
	companyName: {
		DS: true,
		SP: true,
	},
	showInternal: {
		RE: true,
		SO: true,
		AU: true,
		TA: true,
		CMS: true,
		CMI: true,
		OCT: true,
		STK: true,
		PC:  true,
		ODW: true,
		WAS: true,
		PSE: true,

		
	},
	showSapFields: {
		DS: true,
		SP: false,
	}
};
